<template>
  <div>
    <HeaderReceipt header="ดูรายละเอียดใบส่งคืนสินค้า(CN)" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StorageCN_detail/>
  </div>
</template>

<script>
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/completed-task.png";
import StorageCN_detail from "@/components/admin/stock/cn/StorageCN_detail";
export default {
  name: "CnDetail",
  data() {
    return {
      header_image: HeaderImage
    }
  },
  components: {
    StorageCN_detail,
    HeaderReceipt
  }
}
</script>

<style scoped>

</style>
